import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const Promotion = () => {
  const [banner, setBanner] = useState([]);

  useEffect(() => {
    const getBanner = async () => {
      try {
        // eslint-disable-next-line no-unused-vars
        const result = await axios
          .get(process.env.REACT_APP_API_URL + "/image")
          .then((res) => {
            setBanner(res.data);
          });
      } catch (error) {
        console.log(error);
      }
    };
    getBanner();
  }, []);

  return (
    banner.image && (
      <section className="promotion mt-8 w-full flex flex-col md:flex-row gap-2 justify-center items-center overflow-hidden">
        {/* //image size = 822.5 x 320 */}
        <div className="left-banner w-full md:w-3/3 h-[320px]">
          <Link to={banner?.image[0].link}>
            <img
              src={banner?.image[0].imgURL}
              alt="banner"
              className="w-full h-full object-cover hover:opacity-90 transition cursor-pointer"
            />
          </Link>
        </div>

        {/* //image size = 352.5 x 160 */}
        <div className="right-banner w-full md:w-2/7 h-[320px] grid grid-rows-2 gap-2">
          <Link to={banner?.image[1].link}>
            <img
              src={banner?.image[1].imgURL}
              alt="banner"
              className="w-full h-full object-cover hover:opacity-90 transition cursor-pointer"
            />
          </Link>
          <Link to={banner?.image[2].link}>
            <img
              src={banner?.image[2].imgURL}
              alt="banner"
              className="w-full h-full object-cover hover:opacity-90 transition cursor-pointer"
            />
          </Link>
        </div>
      </section>
    )
  );
};

export default Promotion;
